var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_5_",
    "data-name": "user (5)",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15566",
    "data-name": "Path 15566",
    d: "M10,8A4,4,0,1,0,6,4a4,4,0,0,0,4,4Zm0-6.667A2.667,2.667,0,1,1,7.333,4,2.667,2.667,0,0,1,10,1.333Z",
    transform: "translate(-1)",
    fill: "#ff6036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15567",
    "data-name": "Path 15567",
    d: "M9,14a6.007,6.007,0,0,0-6,6,.667.667,0,1,0,1.333,0,4.667,4.667,0,0,1,9.333,0A.667.667,0,0,0,15,20,6.007,6.007,0,0,0,9,14Z",
    transform: "translate(0 -4.667)",
    fill: "#ff6036"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.34004b18aade5e1e5c1301fd62a4b0fd.svg";
export { ForwardRef as ReactComponent };